import { apiType } from '@/macros/tags/types';

export const getTagApiValueFromTypeNumber = type => Object.keys(apiType).find(key => apiType[key] === type);

export default {
  getTagApiValueFromTypeNumber
}
